var exports = {
  "j": "ComponentGalleryTabButtonsTab.module__buttonsWrapper___YjJXc0",
};

module.exports = exports;
